import { useTranslation } from "react-i18next";

interface BankBoxProps {
  bankbalance: number;
  creditsRequired: number;
  matchee_username: string | null;
  noMatch: boolean;
  sent: boolean;
  handleUndo: () => void;
  handleSend: () => void;
  showCompatibility: boolean;
}

const BankBox = ({
  bankbalance,
  creditsRequired,
  matchee_username,
  noMatch,
  sent,
  handleUndo,
  handleSend,
  showCompatibility,
}: BankBoxProps) => {
  const { t } = useTranslation();

  return (
    <div className="border-[2px] border-[#3B3C36] bg-white px-[6px] pb-1 flex flex-col items-center shadow-md">
      <div className="text-[40px] font-sharetech">
        {bankbalance > 0 ? String(bankbalance).padStart(3, "0") : "000"}
      </div>
      <button
        className={`whitespace-nowrap text-white border select-none -mt-2 font-bold border-[#00000020] text-sm px-[10px] py-1 rounded shadow uppercase ${
          matchee_username && !noMatch && bankbalance >= creditsRequired
            ? "cursor-pointer bg-sangati-green"
            : "cursor-not-allowed bg-[#D9D9D9]"
        }`}
        onClick={() => {
          if (
            bankbalance < creditsRequired ||
            !matchee_username ||
            showCompatibility
          ) {
            return;
          }
          sent ? handleUndo() : handleSend();
        }}
      >
        {sent ? t("undo") : t("send")}
      </button>
    </div>
  );
};

export default BankBox;
